<template>
  <label class="flex">
    <input type="checkbox" :checked="value" @input="toggle" />
    <span class="checkmark mb-12 mr-3 bg-white rounded-full w-6 h-6"></span>
    <span class="text-xs md:text-lg">
    <slot></slot>
    </span>
  </label>
</template>

<script>
export default {
  name: "CheckMark",
  props:["value"],
  data() {
    return {
      checked: false,
    };
  },
  methods: {

    toggle() {
        console.log("emitting checkstate",this.checked);
      this.value=!this.value
      this.$emit("input", this.value);
    },
  },
};
</script>

<style scoped>

label{
    position:relative;
}

input[type="checkbox"] {
  /* position: absolute; */
  opacity: 1;
  cursor: pointer;
  height: 0;
  width: 0;
}

input[type="checkbox"]:focus,
input[type="checkbox"]:active{
    display: none;
}

/* Create a custom checkbox */
.checkmark {
  position: relative;
  top: 0;
  left: 0;

}

/* On mouse-over, add a grey background color */
label:hover input ~ .checkmark {
  background-color: #fff;
}

/* When the checkbox is checked, add a blue background */
label input:checked ~ .checkmark {
  background-color: #FF3C39;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
label input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
label .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
